import logger from './logger';

export const LOADING_MESSAGE = "Loading...";

// BASE_SERVER_URL routes calls to the orchestrator (Demo section's
// /api/v1/demo). In Docker/production, leave unset — nginx.frontend.conf
// proxies /api/ to the backend container. Local override via
// VITE_BASE_SERVER_URL.
export const BASE_SERVER_URL = (import.meta.env as any).VITE_BASE_SERVER_URL || '';

// CONTACT_FORM_URL is a *separate* endpoint — the public API Gateway in
// front of the propvetter-contact-form Lambda → SES. It deliberately
// bypasses the local nginx + orchestrator stack, since contact form
// emails are owned by AWS (Lambda + SES), not the in-cluster backend.
// Both the home-page and /consulting forms POST here. Public URL —
// CORS + the Lambda handler are the access controls.
export const CONTACT_FORM_URL =
  (import.meta.env as any).VITE_CONTACT_FORM_URL ||
  'https://ulgfyk5hlg.execute-api.us-west-2.amazonaws.com/prod/api/contact';

logger.debug('Using BASE_SERVER_URL:', BASE_SERVER_URL || '(relative)');
logger.debug('Using CONTACT_FORM_URL:', CONTACT_FORM_URL);
